<template>
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
  >
    <path d="M0 0.5C0 0.223858 0.223858 0 0.5 0H11.5C11.7761 0 12 0.223858 12 0.5C12 0.776142 11.7761 1 11.5 1H0.5C0.223858 1 0 0.776142 0 0.5ZM0 4.5C0 4.22386 0.223858 4 0.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H0.5C0.223858 5 0 4.77614 0 4.5ZM0 8.5C0 8.22386 0.223858 8 0.5 8H11.5C11.7761 8 12 8.22386 12 8.5C12 8.77614 11.7761 9 11.5 9H0.5C0.223858 9 0 8.77614 0 8.5Z" />
  </svg>
</template>
